export default {
    profileSearches: function() {
        return this.$store.state.profileSearches.filter(search => {
            return search && search.profiles && search.profiles.length > 0
        })
    },
    jobDetails: function() {
        return this.$store.state.jobDetails
    },
    totalFee() {
        const self = this
        let value = 0

        self.profileSearches.forEach(search => {
            const profiles = search.profiles
            profiles.forEach(profile => {
                const symplaEvents = this.$store.state.profilesFoundBySymplaEvents[profile.id]
                const profileWasFoundBySymplaEvent = symplaEvents?.length > 0
                if (profileWasFoundBySymplaEvent) {
                    let fee = search.fee
                    symplaEvents.forEach(symplaEvent => {
                        let event = this.$store.state.symplaEvents.filter(e => {
                            return symplaEvent === e.id
                        })

                        if (event[0] && event[0].tax) {
                            fee += (fee * (event[0].tax / 100))
                        }
                    })

                    value += fee
                } else {
                    value += search.fee
                }
            })
        })

        return value
    },
    amount: function() {
        const self = this,
            fee = self.totalFee,
            totalDays = this.$store.state.profileFinder.event.totalDays,
            totalPerDay = this.applyTaxes(fee),
            amount = totalPerDay * totalDays

        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount)
    },
    allProfiles: function() {
        const self = this

        let result = []
        self.profileSearches.forEach(search => {
            result.push(...search.profiles)
        })

        return result
    },
    eventCreatedMessage() {
        return this.$store.state.settings?.filter(setting => {
            return setting.id === 'event_created_message'
        })[0]?.value
    },
    profilesFoundBySymplaEvents: function() {
        return this.$store.state.profilesFoundBySymplaEvents
    }
}
